import z from "zod";

export type TranslationNameField = "nameAr" | "nameTr" | "nameFa" | "nameEn";

export const LanguageEnum = z.enum(["ar", "tr", "en", "fa"]);
export type SupportedLanguages = z.infer<typeof LanguageEnum>;
export const LanguageValues = LanguageEnum.options as [SupportedLanguages, ...SupportedLanguages[]];

export const LanguageMap: Record<SupportedLanguages, TranslationNameField> = {
  en: "nameEn",
  tr: "nameTr",
  ar: "nameAr",
  fa: "nameFa",
};

export const languageDetails = [
  { code: "en", name: "English", nativeName: "English", flag: "🇺🇸" },
  { code: "ar", name: "Arabic", nativeName: "العربية", flag: "🇸🇦" },
  { code: "tr", name: "Turkish", nativeName: "Türkçe", flag: "🇹🇷" },
  { code: "fa", name: "Persian", nativeName: "فارسی", flag: "🇮🇷" },
] as const;
